<template>
  <div v-if="isLoaded">
    <div
        class="content-body"
        v-bind:class="{ fullscreen_expand: isFullscreen }"
    >
      <div class="row match-height">
        <div class="col-xl-12 col-lg-12">
          <div class="card" style="">
            <div class="card-header custom-card-header">
              <h4 class="card-title">Montagem de Carga</h4>
              <ToolbarActions
                  :is-fullscreen="isFullscreen"
                  :permissions="{
                    alterartransportadora: getPermissionFw('montagemcarga.alterartransportadora'),
                    store: getPermissionFw('montagemcarga.store'),
                    status: getPermissionFw('montagemcarga.status')
                  }"
                  @edit-transportadora-lote="onEditTransportadoraLote"
                  @store="onStore"
                  @create="onCreate"
                  @filter-reset="onFilterReset"
                  @toggle-fullscreen="expandFullscreenFw"
                  @filter-toggle="onFilterShowHideFw"
              />
            </div>
            <div class="card-content">
              <div class="table-responsive">
                  <SummaryHeader
                    :form="form"
                    :currency="getCurrency"
                  >
                    <template slot="errors">
                      <NotificationBarError
                        v-bind:errors_array="errors_array"
                        type="alert"
                      ></NotificationBarError>
                    </template>
                  </SummaryHeader>
                </div>
            </div>
            <div class="card-content mb-1">
              <div class="table-responsive">
                <div v-if="vuetableFilterRow">
                  <vuetable-filterbar :tabela="'doc_fiscal'">
                  </vuetable-filterbar>
                </div>
                <div class="loadingDataPosition">
                  <div v-if="loadingData" class="p-2">
                    <b-skeleton-table
                      :rows="10"
                      :columns="8"
                      :table-props="{ bordered: true, striped: true }"
                      class="rounded-lg overflow-hidden"
                    ></b-skeleton-table>
                  </div>
                  <div v-show="!loadingData">
                    <div>
                      <a
                          @click="searchAll()"
                          v-b-tooltip
                          title="Selecionar todas as páginas"
                          v-if="getPermissionFw('montagemcarga.index') && hasData"
                      ><i
                          class="fa fa-check-square-o fa-lg"
                          style="margin: 0px 0px 5px 4px"
                      ></i
                      ></a>
                    </div>
                    <vuetable
                        ref="vuetable"
                        api-url="/api/montagemcarga"
                        :fields="fields"
                        :css="css"
                        :append-params="moreParams"
                        track-by="docfisId"
                        data-path="data.items"
                        pagination-path="meta"
                        detail-row-component="montagemcarga-detalhes"
                        @vuetable:cell-clicked="onDetail"
                        @vuetable:load-error="onError"
                        @vuetable:pagination-data="onPaginationData"
                        :load-on-start="false"
                        :no-data-template="noDataMessage"
                        :key="filterApplied"
                        @vuetable:load-success="onLoadSuccess"
                        @vuetable:loaded="onLoaded"
                    >
                    <template slot="doc" slot-scope="props">
                      <span
                          v-if="
                          props.rowData.cargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc.doc
                        "
                      >{{
                          props.rowData.cargaDoc.docCargaDoc.doc.numFiscal
                        }}</span>
                    </template>
                    <template slot="dt_emi_cte" slot-scope="props">
                      <span
                          v-if="
                          props.rowData.cargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc.doc
                        "
                      >{{
                          formatDate(
                              props.rowData.cargaDoc.docCargaDoc.doc.dtEmi,
                              "DD/MM/YYYY HH:mm"
                          )
                        }}</span>
                    </template>

                    <template slot="num_carga" slot-scope="props">
                      <span v-if="props.rowData.cargaBipDoc && props.rowData.cargaBipDoc.carga" class="carga-number">
                        {{ props.rowData.cargaBipDoc.carga.numCarga }}
                      </span>
                    </template>

                    <template slot="status_bip" slot-scope="props">
                      <BadgeStatus :row-data="props.rowData" type="montagem" />
                    </template>

                    <template slot="tp_operacao" slot-scope="props">
                      <BadgeStatus :row-data="props.rowData" type="operacao" />
                    </template>
                    <template slot="tp_processo" slot-scope="props">
                      <BadgeStatus :row-data="props.rowData" type="processo" />
                    </template>

                    <template slot="cliente_nf" slot-scope="props">
                      <span
                      >{{ props.rowData.DocFiscalPartesEnv.desNome }} -
                        {{ props.rowData.DocFiscalPartesEnv.desCnpj }}
                      </span>
                    </template>
                    <template slot="redespacho_nf" slot-scope="props">
                      <span
                      >{{ props.rowData.DocFiscalPartesEnv.redNome }} -
                        {{ props.rowData.DocFiscalPartesEnv.redCnpj }}
                      </span>
                    </template>
                    <template slot="obs" slot-scope="props">
                      <span
                          v-if="
                          props.rowData.cargaBipDoc != null &&
                          props.rowData.cargaBipDoc.carga != null
                        "
                      >
                        {{ props.rowData.cargaBipDoc.carga.obs }}
                      </span>
                    </template>
                    <template slot="regiao" slot-scope="props">
                      <span
                          v-if="
                          props.rowData.cargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc.doc.regiaoDespesa
                        "
                      >{{
                          props.rowData.cargaDoc.docCargaDoc.doc.regiaoDespesa
                              .cd
                        }}
                      </span>
                      <span
                          v-if="
                          props.rowData.cargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc &&
                          props.rowData.cargaDoc.docCargaDoc.doc.docRps !== null
                        "
                      >{{
                          props.rowData.cargaDoc.docCargaDoc.doc.docRps
                              .doc_rps_regiao
                        }}
                      </span>
                    </template>
                    <template slot="peso_bruto">
                      <span>{{ this.pesoBruto }}</span>
                    </template>
                    <template slot="actions" slot-scope="props">
                      <div class="custom-actions">
                        <a
                            v-if="
                            props.rowData.cargaBipDoc !== null &&
                            props.rowData.cargaBipDoc.carga != null &&
                            props.rowData.cargaBipDoc.carga.status.valor == 2
                          "
                            @click="onCreate(props.rowData, 2)"
                            v-b-tooltip
                            title="Adicionar nota fiscal a carga"
                        ><i class="fa fa-file"></i
                        ></a>
                        <a
                            @click="onDetail(props.rowData, null, null)"
                            v-b-tooltip
                            title="Ver detalhes"
                        ><i class="fa fa-plus"></i
                        ></a>
                        <a
                            v-if="props.rowData.docFiscalUnidade.length > 1"
                            v-b-tooltip
                            :title="
                            'Transferencia de: ' +
                            props.rowData.docFiscalUnidade[
                              props.rowData.docFiscalUnidade.length - 2
                            ].descr
                          "
                        ><i class="fa fa-sign-in"></i
                        ></a>
                      </div>
                    </template>
                  </vuetable>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="col-md-12">
                    <div class="pull-left pagination-detail">
                      <vuetable-pagination-info
                          ref="paginationInfo"
                          :css="css.pagination"
                          info-class="pull-left"
                      ></vuetable-pagination-info>
                    </div>
                    <div class="pull-right m-a-0">
                      <vuetable-pagination
                          ref="pagination"
                          :css="css.pagination"
                          @vuetable-pagination:change-page="onChangePage"
                      ></vuetable-pagination>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>
      </div>
      <MontagemCargaTransportadoraForm ref="montagemcargatransportadora">
      </MontagemCargaTransportadoraForm>
      <MontagemCargaForm ref="montagemcargaform"></MontagemCargaForm>
      <MontagemCargaObs ref="montagemcargaobs"></MontagemCargaObs>
    </div>
  </div>
</template>

<style scoped>
.carga-number {
  font-size: 0.95rem;
  font-weight: 700;
  color: #374151;
  letter-spacing: 0.025em;
}

@media (max-width: 767.98px) {
    .custom-card-header {
        display: flex !important;
        flex-direction: column !important;
        align-items: center !important;
        text-align: center !important;
        padding-bottom: 0 !important;
    }
}
</style>

<script>
import Vuetable from "../components/Vuetable";
import VuetablePagination from "../components/VuetablePagination";
import VuetablePaginationInfo from "../components/VuetablePaginationInfo";
import MontagemCargaFilterBar from "./MontagemCargaFilterBar";
import BadgeStatus from "./MontagemCarga/BadgeStatus.vue";
import SummaryHeader from "./MontagemCarga/SummaryHeader.vue";
import ToolbarActions from "./MontagemCarga/ToolbarActions.vue";
import moment from "moment";
import accounting from "accounting";
import MontagemCargaDetalhes from "./MontagemCargaDetalhes";
import NotificationBarError from "../components/NotificationBarError";

const MontagemCargaTransportadoraForm = () => import("./MontagemCargaTransportadoraForm");
const MontagemCargaForm = () => import("./MontagemCargaForm");
const MontagemCargaObs = () => import("./MontagemCargaObs");

Vue.component("montagemcarga-detalhes", MontagemCargaDetalhes);
Vue.component("montagemcargaobs", MontagemCargaObs);

export default {
  components: {
    NotificationBarError,
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
    MontagemCargaTransportadoraForm,
    MontagemCargaForm,
    MontagemCargaObs,
    BadgeStatus,
    SummaryHeader,
    ToolbarActions,
    "vuetable-filterbar": MontagemCargaFilterBar,
  },
  data() {
    return {
      dataExport: [],
      dados: [],
      modal_titulo: "",
      modal_botao: "",
      modal_acao: "",
      pesoBruto: "",
      checkbox: [],
      errors_array: [],
      loading: false,
      isDisabled: false,
      loadingData: false,
      showModal: false,
      optionsRegiao: [],
      filter_data_store: {},
      filterApplied: false,
      hasData: false,
      noDataMessage: "Por favor, utilize um dos filtros acima para carregar os dados (N° Carga, N° NF ou CTE/RPS).",
      filtros_form: new Form({
        num_carga: "",
        num_nf: "",
        num_fiscal_cte: "",
        observacao: "",
        consulta_completa: "2",
      }),
      form: new Form({
        vlr_total_nfs: 0,
        qtde_nfs: 0,
        vlr_total_peso_liquido: 0,
        vlr_total_peso_bruto: 0,
        vlr_total_volume: 0,
        docfis: [],
        vlr_total_nfs2: 0,
        vlr_total_peso_liquido2: 0,
        vlr_total_peso_bruto2: 0,
        vlr_total_volume2: 0,
      }),
      helpForm: new Form({
        recordCollection: [],
        docfisCollection: [],
        status: "",
      }),
      fields: [
         {
          name: "__checkbox",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
        {
          name: "__slot:obs",
          title: "Obs",
        },
        {
          name: "__slot:doc",
          title: "CTE/RPS",
        },
        {
          name: "__slot:num_carga",
          title: "N° Carga",
        },
        {
          name: "__slot:status_bip",
          title: "Status BIP",
        },
        {
          name: "__slot:tp_processo",
          title: "Processo",
        },
        {
          name: "__slot:tp_operacao",
          title: "Operação",
        },
        {
          name: "numFiscal",
          title: "N° NF",
        },
        {
          name: "serie",
          title: "Série",
        },
        {
          name: "__slot:dt_emi_cte",
          title: "Dt emissão",
        },
        {
          name: "__slot:cliente_nf",
          title: "Cliente NF",
        },
        {
          name: "__slot:redespacho_nf",
          title: "Redespacho",
        },        
        {
          name: "pesoBruto",
          title: "Peso bruto",
          callback: "formatNumber",
        },
        {
          name: "qtdVolume",
          title: "Volume",
          callback: "formatNumber",
        },
        {
          name: "vlrTotalNfs",
          title: "Valor NF",
          callback: "formatNumber",
        },
        {
          name: "__slot:actions",
          title: "Ações",
          titleClass: "center aligned",
          dataClass: "center aligned",
        },
      ],
      css: {
        loadingClass: "loading",
        ascendingIcon: "glyphicon glyphicon-chevron-up",
        descendingIcon: "glyphicon glyphicon-chevron-down",
        handleIcon: "glyphicon glyphicon-menu-hamburger",
      },
      moreParams: {},
    };
  },
  mounted() {
    this.$events.$on("filter-set", (eventData) => this.onFilterSet(eventData));
    this.$events.$on("filter-reset", (e) => this.onFilterReset());
    this.getLivGeral();
  },
  watch: {
    filterApplied(value) {
      if (value) {
        this.noDataMessage = "Nenhum dado foi encontrado, por favor verifique se o valor está correto dos filtros";
      } else {
        this.noDataMessage = "Por favor, utilize um dos filtros acima para carregar os dados (N° Carga, N° NF ou CTE/RPS).";
      }
    }
  },
  methods: {
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);
    },
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    searchAll(data_filter, tipo) {
      if (tipo == 2) {
        this.filter_data_store = data_filter;
      }
      if (tipo != 2) {
        this.loadingData = true;
        if (this.$refs.vuetable.selectedTo.length == 0) {
          this.filtros_form.num_carga = this.filter_data_store.num_carga;
          this.filtros_form.num_nf = this.filter_data_store.num_nf;
          this.filtros_form.num_fiscal_cte =
              this.filter_data_store.num_fiscal_cte;
          this.filtros_form.observacao =
              this.filter_data_store.observacao;
          this.filtros_form.consulta_completa =
              this.filter_data_store.consulta_completa;
          this.filtros_form
              .post("/api/montagemcarga/all")
              .then((response) => {
                new ReturnApi(response, this, true, false, false);
                response.forEach((obj) => {
                  this.$refs.vuetable.selectedTo.push(parseFloat(obj.docfis_id));
                });
                this.loadingData = false;
              })
              .catch((errors) => {
                new ReturnApi(errors, this);
                this.loadingData = false;
              });
        } else {
          this.$refs.vuetable.selectedTo = [];
          this.loadingData = false;
        }
      }
    },
    onFilterSet(data_filter) {
      this.loadingData = true;
      this.moreParams = {
        num_carga: data_filter.num_carga,
        num_nf: data_filter.num_nf,
        num_fiscal_cte: data_filter.num_fiscal_cte,
        observacao: data_filter.observacao,
        consulta_completa: data_filter.consulta_completa,
      };

      // Validação: Pelo menos um filtro preenchido
      if (!this.moreParams.num_carga && !this.moreParams.num_nf && !this.moreParams.num_fiscal_cte && !this.moreParams.observacao) {
        this.loadingData = false;
        this.hasData = false;
        this.onFilterReset();
        this.$store.commit("setVuetableFilterButton", false);
        return;
      }
      
      if (JSON.stringify(this.moreParams) != "{}") {
        this.filterApplied = true;
        this.hasData = false;
        this.searchAll(this.moreParams, 2);
      }
      
      Vue.nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    onFilterReset() {
      this.moreParams = {};
      this.filterApplied = false;
      this.hasData = false;
      this.$refs.vuetable.selectedTo = [];
      this.filter_data_store = {};
      this.form.vlr_total_nfs = 0;
      this.form.vlr_total_peso_liquido = 0;
      this.form.vlr_total_peso_bruto = 0;
      this.form.vlr_total_volume = 0;
      this.form.qtde_nfs = 0;

      if (this.$refs.vuetable) {
        this.$refs.vuetable.setData([]);
      }
      this.loadingData = false;
    },
    onLoaded: function () {
      this.dataExport.push(this.$refs.vuetable.tableData);
      Vue.nextTick(() => {
        this.hasData = this.$refs.vuetable && this.$refs.vuetable.tableData.length > 0;
      });
      this.dataExport.forEach((obj2) => {
        obj2.forEach((obj3) => {
          this.dados.push({
            docfisId: obj3.docfisId,
            vlrTotalNfs: obj3.vlrTotalNfs,
            pesoLiquido: obj3.pesoLiquido,
            pesoBruto: obj3.pesoBruto,
            qtdVolume: obj3.qtdVolume,
          });
        });
      });
      this.somaPesos();
      this.loadingData = false;
      this.$store.commit("setVuetableFilterButton", false);
    },
    onLoadSuccess(response) {
      const payload = response.data.data;
      const items = payload.items || [];
      this.hasData = items.length > 0;
      
      // Só exibe o resumo se houver filtro por Número de Carga e houver dados
      if (this.moreParams.num_carga && items.length > 0 && payload.summary) {

        this.form.qtde_nfs = payload.summary.total_notas || 0;
        this.form.vlr_total_nfs = payload.summary.vlr_total_nfs_carga || 0;
        this.form.vlr_total_peso_bruto = payload.summary.peso_bruto_total_carga  || 0;
        this.form.vlr_total_peso_liquido = payload.summary.peso_liquido_carga  || 0;
        this.form.vlr_total_volume = payload.summary.qtd_volume_carga || 0;
      } else {
        // Zera os totais quando não for busca por carga ou se a carga estiver vazia
        this.form.qtde_nfs = 0;
        this.form.vlr_total_nfs = 0;
        this.form.vlr_total_peso_bruto = 0;
        this.form.vlr_total_peso_liquido = 0;
        this.form.vlr_total_volume = 0;
      }
      this.somaPesos();
    },
    onCreate(data, tipo) {
      this.$refs.montagemcargaform.onCreate(data, tipo);
    },
    onStore() {
      this.errors_array = "";
      this.errors_array = [];
      this.form.docfis = "";
      this.form.docfis = [];
      this.loadingData = true;
      this.$refs.vuetable.selectedTo.forEach((obj) => {
        this.form.docfis.push({docfis_id: obj});
      });
      this.form
          .post("/api/montagemcarga/store")
          .then((response) => {
            new ReturnApi(response, this);
            this.onFilterReset();
            this.docfis = [];
            this.loadingData = false;
          })
          .catch((errors) => {
            new ReturnApi(errors, this, true, null, null, false);
            this.loadingData = false;
            this.errors_array = "";
            this.errors_array = [];
            for (var property in errors) {
              if (errors.hasOwnProperty(property)) {
                if (typeof errors[property] === "object") {
                  errors[property].forEach((obj) => {
                    this.errors_array.push({
                      erro: obj,
                    });
                  });
                }
              }
            }
          });
    },
    onEditTransportadora(data) {
      this.$refs.montagemcargatransportadora.onEdit(
          data.doc_fiscal_transporte.doc_fiscal_transporte_transpor
      );
    },
    onEditTransportadoraLote() {
      const docfisCollection = [...this.$refs.vuetable.selectedTo];
      this.$refs.montagemcargatransportadora.onEditLote(docfisCollection);
    },
    onEditarObs(data) {
      this.$refs.montagemcargaobs.onEdit(
          data.carga_bip_doc.carga.carga_id,
          data.carga_bip_doc.carga.obs
      );
    },
    somaPesos() {
      if (!this.$refs.vuetable || !this.$refs.vuetable.tableData) return;

      this.$refs.vuetable.tableData.forEach((item, i) => {
        let totalPesoBruto = 0;
        let totalPesoLiquido = 0;
        let totalVolume = 0;

        if (item.docFiscalTransporte && item.docFiscalTransporte.docFiscalTransporteVolume) {
          item.docFiscalTransporte.docFiscalTransporteVolume.forEach((vol) => {
            totalPesoBruto += parseFloat(vol.pesoBruto || 0);
            totalPesoLiquido += parseFloat(vol.PesoLiquido || 0);
            totalVolume += parseFloat(vol.qtdVolume || 0);
          });
        }

        // Atualização reativa das propriedades do item
        Vue.set(item, 'pesoBruto', totalPesoBruto);
        Vue.set(item, 'PesoLiquido', totalPesoLiquido);
        Vue.set(item, 'qtdVolume', totalVolume);

        if (item.cargaBipDoc !== null) {
          let totalVolumeBipados = 0;
          let totalVolumeCarga = 0;

          item.cargaBipDoc.cargaBipDocVolume.forEach((volBip) => {
            if (volBip.statusMontagem && volBip.statusMontagem.valor == 1) {
              totalVolumeBipados += 1;
            }
            totalVolumeCarga += 1;
          });

          Vue.set(item, 'vlrTotalBips', totalVolumeBipados);
          Vue.set(item, 'vlrTotalVolumes', totalVolumeCarga);
        }
      });
    },
    getUnidades(data) {
      var retorno = "";
      data.forEach((obj, i) => {
        if (i + 1 == data.length) {
          retorno = retorno + obj.unidade.descr;
        } else {
          retorno = retorno + obj.unidade.descr + " / ";
        }
      });
      return retorno;
    },
    getLivGeral() {
      this.helpForm
          .get("/api/montagemcarga/jsonlistgeral")
          .then((response) => {
            new ReturnApi(response, this, true, false, false);
            response.regiao.forEach((obj) => {
              this.optionsRegiao.push({
                label: obj.cd + "-" + obj.descr,
                regiao_id: obj.regiao_id,
                value: obj.regiao_id,
              });
            });
            this.$events.fire("load-json");
          })
          .catch((errors) => {
            new ReturnApi(errors, this);
          });
    },
    onDetail(data, field, event) {
      this.$refs.vuetable.toggleDetailRow(data.docfisId);
    },
    formatNumber(value) {
      return accounting.formatNumber(value, 2, ".", ",");
    },
    formatDate(value, fmt = "DD/MM/YYYY HH:mm") {
      return value == null ? "" : moment(value, "YYYY-MM-DD HH:mm").format(fmt);
    },
    onError(response) {
      new ReturnApi(response.response, this, true, true, false);
    },
  },
  computed: {
    vuetableFilterRow: {
      get() {
        return this.$store.state.vuetable.filterRow;
      },
    },
    isLoaded: {
      get() {
        return this.$store.getters.isloaded;
      },
    },
    isFullscreen: {
      get() {
        return this.$store.getters.is_full_screen;
      },
    },
    getCurrency: {
      get() {
        return this.$store.getters.currency ? this.$store.getters.currency.currency : 'R$';
      },
    },
  },
};
</script>